/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./formattingOptions.vue?vue&type=template&id=58af3f69&scoped=true"
import script from "./formattingOptions.vue?vue&type=script&lang=js"
export * from "./formattingOptions.vue?vue&type=script&lang=js"
import style0 from "./formattingOptions.vue?vue&type=style&index=0&id=58af3f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af3f69",
  null
  
)

export default component.exports